export default "__VITE_ASSET__BVLoKBAe__"